import {
  postAnnouncementsList as getAnnouncementsApi,
  postAnnouncement,
} from '../../../../../ui-kitchen/src/api';
import { getPageContext } from '../../../../../ui-kitchen/src/utils';
import {
  HOMEPAGE,
  SEARCH_PAGE,
  ACCOUNT,
  EVENT_PAGE,
  EVENTS_LANDING_PAGE,
  VENUE_PAGE,
} from '../../../../../ui-kitchen/src/utils/getPageContext';

const PAGE_NAME_MAP = {
  [HOMEPAGE]: 'home_page',
  [SEARCH_PAGE]: 'search_page',
  [ACCOUNT]: 'account_page',
  [EVENT_PAGE]: 'event_page',
  [EVENTS_LANDING_PAGE]: 'events_landing_page',
  [VENUE_PAGE]: 'venue_page',
};

export const getAnnouncementParams = () => {
  const { pathname } = window.location;
  const context = getPageContext(pathname);
  return {
    page: PAGE_NAME_MAP[context],
  };
};

export const getAnnouncements = ({ deviceId, locationCode, flowContext }) => {
  const { pathname } = window.location;
  const context = getPageContext(pathname);

  const page = flowContext || PAGE_NAME_MAP[context] || '';
  return getAnnouncementsApi({
    page,
    uuid: deviceId,
    location_id: locationCode,
  }).then((result) => {
    if (!result.length) return null;
    return result;
  });
};

export const postAnnouncementViewed = (params) => {
  const { deviceId, id, remindMeLater } = params;

  return postAnnouncement({
    uuid: deviceId,
    announcement_id: id,
    ...('remindMeLater' in params && { remind_me_later: remindMeLater }),
  });
};
